export default {
  path: '/settings',
  name: 'settings',
  component: () => import('./_views/KernelSettings.vue'),
  meta: {
    title: 'Settings',
  },
};
